// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"styles_pageContainer__3DbWB","inner":"styles_inner__7gLF5"};